/* import __COLOCATED_TEMPLATE__ from './signup-work-form.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { dropTask } from 'ember-concurrency';
import { showModal } from 'sh-www/utils/modal-controls';
import { handleErrorResponseWithModal } from 'sh-www/utils/handles-errors';
import { createCache, getValue } from '@glimmer/tracking/primitives/cache';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';
import clsx from 'clsx';

const CLASS_NAME = 'GLM-freelancer-signup-form';

class SignupWorkForm extends Component {
  @service('commands.projectdigest-commands') projectdigestCommandService;
  @service media;
  @service router;

  @tracked projectDigests = this.args.user.projectdigests?.toArray() ?? [];

  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME
    );
  }

  get baseClassName() {
    return CLASS_NAME;
  }

  #hasVerificationCache = createCache(() => {
    return this.projectDigests.some(({ mostRecentProjectDigestVerification }) => !!mostRecentProjectDigestVerification);
  });

  get hasVerification() {
    return getValue(this.#hasVerificationCache);
  }

  get showVerificationWarning() {
    return !this.hasVerification && !this.args.user.isWhitelisted;
  }

  get showSubmit() {
    return this.projectDigests.length > 0 || this.args.user.isWhitelisted;
  }

  get isSubmitDisabled() {
    return this.submitTask.isRunning
      || (!this.args.user.isWhitelisted && (this.projectDigests.length < 3 || !this.hasVerification));
  }

  get submitButtonText() {
    if (this.args.user.isWhitelisted) {
      return this.projectDigests.length > 0
        ? 'Complete Sign-up'
        : 'Skip for now'
    }

    const projectsLeft = 3 - this.projectDigests.length;
    return this.projectDigests.length >= 3
      ? 'Complete Sign-up'
      : `${projectsLeft} more ${projectsLeft === 1 ? 'project' : 'projects'} needed`;
  }

  @action
  handleBackClicked() {
    this.router.transitionTo(EMBER_ROUTE_NAMES.SIGNUP__STEP__BACKGROUND);
  }

  @action
  deleteProjectDigest(projectToDelete) {
    const modalModel = {
      titleText: `Delete this work sample?`,
      actionButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      confirmAction: () => {
        this.projectdigestCommandService.deleteProjectDigest(projectToDelete).then(() => {
          this.projectDigests = this.projectDigests.filter(({ id }) => {
            return id !== projectToDelete.id;
          });
          projectToDelete.unloadRecord();
        }).catch((error) => {
          handleErrorResponseWithModal(this, error);
        });
      },
    };
    showModal(this, 'confirmation', modalModel);
  }

  @action
  handleVerificationClicked(projectDigest) {
    showModal(this, 'work-samples/verification-method', { projectDigest });
  }

  @dropTask
  *submitTask(e) {
    e.preventDefault();
    try {
      yield this.args.updateUser();
    } catch (error) {
      handleErrorResponseWithModal(this, error);
    }
  }
}

export default SignupWorkForm;
